import { getRecentRequests } from '../api/apiClient';
import { getFeedbackScreen } from './feedbackScreen';

/**
 * Собирает технический контекст обращения из формы обратной связи.
 * НЕ включает X-Telegram-Init-Data и тела запросов — только безопасные метаданные
 * и след последних запросов (метод + путь + статус) из apiClient.
 *
 * @returns {{
 *   platform: string, telegramVersion: string, appVersion: string,
 *   colorScheme: string, languageCode: string, startParam: string,
 *   viewport: string, userAgent: string, recentRequests: string[]
 * }}
 */
export const collectFeedbackContext = () => {
  const tg = window.Telegram?.WebApp;
  const nz = (v) => (v === undefined || v === null || v === '' ? undefined : v);

  return {
    platform: nz(tg?.platform),
    telegramVersion: nz(tg?.version),
    appVersion: nz(process.env.REACT_APP_BUILD_VERSION),
    colorScheme: nz(tg?.colorScheme),
    languageCode: nz(tg?.initDataUnsafe?.user?.language_code),
    startParam: nz(tg?.initDataUnsafe?.start_param),
    // Экран/режим при одинаковом URL (просмотр vs редактирование и т.п.), если страница его сообщила.
    screen: nz(getFeedbackScreen()),
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    userAgent: nz(navigator.userAgent),
    recentRequests: getRecentRequests(),
  };
};
